import { NavLink } from "react-router";
import cn from "classnames";
import moboConfigurator from "moboConfigurator";
import { useMemo } from "react";
import styles from "./Segment.module.scss";

export type SegmentProps = {
  to?: string | null;
  label: string;
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
  init?: () => void;
  end?: boolean;
};

function Segment(props: SegmentProps) {
  const { to, label, className, onClick, disabled, end = true } = props;
  const accountId = useMemo(() => moboConfigurator.getMoboId(), []);

  return (
    <div role="tab" className={styles.tab}>
      {disabled ? (
        <span style={{ cursor: "pointer" }} className={cn(className, "segment")}>
          {label}
        </span>
      ) : (
        <NavLink
          end={end}
          to={{ pathname: to || "/", hash: accountId ? `#moboId=${accountId}` : undefined }}
          className={({ isActive }) => cn(className, "segment", { "active-segment": isActive })}
          onClick={onClick}
          role="link"
        >
          {label}
        </NavLink>
      )}
    </div>
  );
}

export default Segment;
